<template>
    <section id="default-page">
        <div class="container full-width">
            <div class="row">
                <div class="search-result-top">
                    <div class="top">
                        <div class="left">
                            <h2 v-if="vehicle_id">Activity for vehicle {{vehicle_id}}</h2>
                            <h2 v-else>Last {{ days }} days of activity</h2>
                        </div>
                    </div>
                    <div class="bottom">
                        <b-form-select v-model="days" :options="daysOptions" class="form-control" @change="onDayChange"></b-form-select>

                        <select v-model="per_page">
                            <option :value="100">100 per page</option>
                            <option :value="500">500 per page</option>
                            <option :value="1000">1000 per page</option>
                            <option :value="10000000">Show max</option>
                        </select>
                    </div>
                </div>
                <div class="container-table">
                    <b-table
                            class="list-table"
                            :items="result"
                            :fields="fields"
                            responsive=""
                    >
                        <template v-slot:cell(date)="data">
                            {{moment.unix(data.item.date).format("MMM D Y")}}
                        </template>
                        <template v-slot:cell(userName)="data">
                            <a :href="$laravelRoute('users.show', data.item.userId)" class="link">
                                {{ data.item.userName }}</a>
                        </template>
                        <template v-slot:cell(salesRep)="data">
                            <a :href="'/users-history/' + data.item.salesRepId" class="link">
                                {{ data.item.salesRep }}</a>
                        </template>
                        <template v-slot:cell(views)="data">
                            <a v-if="data.item.views > 0" :href="viewsLink(data)" class="link">
                                {{ data.item.views }}
                            </a>
                            <template v-else>{{ data.item.views }}</template>
                        </template>
                        <template v-slot:cell(bids)="data">
                            <a v-if="data.item.bids > 0" :href="bidLink(data)" class="link">
                                {{ data.item.bids }}
                            </a>
                            <template v-else>{{ data.item.bids }}</template>
                        </template>
                    </b-table>
                </div>
                <div class="bottom-table">
                    <b-pagination
                        v-if="total > 0"
                        :total-rows="total"
                        v-model="current_page"
                        :per-page="per_page"
                    ></b-pagination>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    import {mapState} from 'vuex'

    export default {
        props: [
            'userType',
        ],
        created(){
            if (this.$route.query && this.$route.query.vid) {
                this.vehicle_id = this.$route.query.vid
                this.days = 60
            }
            this.getData();
        },
        data() {
            return {
                vehicle_id: null,
                days: 7,
                current_page: 1,
                per_page: 100,
                daysOptions: [
                    {text: '7 days', value: 7},
                    {text: '14 days', value: 14},
                    {text: '30 days', value: 30},
                    {text: '60 days', value: 60},
                ],
                moment: window.moment
            }
        },
        computed: {
            ...mapState({
                history: state => state.usersHistory.all,
                total: state => state.usersHistory.total,
            }),
            result(){
                if (this.per_page > this.total) {
                    return this.history
                }
                return this.history.slice((this.current_page - 1) * this.per_page, this.current_page * this.per_page);
            },
            fields(){
                let fields = [{
                        key: 'date',
                        sortable: true,
                    },
                    {
                        key: 'userName',
                        label: 'User',
                        sortable: true,
                    },
                    {
                        key: 'company.name',
                        label: 'Company',
                        sortable: true,
                    }
                ];
                if (!this.vehicle_id) {
                    fields.push({
                        key: 'views',
                        label: 'Number Of Cars Viewed',
                        sortable: true,
                    })
                }
                fields.push({
                    key: 'bids',
                    label: 'Number Of Bids',
                    sortable: true,
                })
                if (this.userType !== 'reps') {
                    fields.push({
                        key: 'salesRep',
                        label: 'Rep of customer',
                        sortable: true,
                    });
                }
                return fields;
            },
        },
        methods: {
            onDayChange(){
                this.getData()
            },
            getData(params = {}) {
                this.$nextTick(() => {
                    let data = Object.assign({
                        days: this.days,
                    }, params);
                    if (this.vehicle_id) {
                        data.vehicle_id = this.vehicle_id
                    }
                    if (this.userType) {
                        data.type = this.userType
                    }
                    this.$store.dispatch('usersHistory/get', data);
                })
            },
            bidLink(data){
                const date = this.moment.unix(data.item.date).format("YYYY-MM-DD");
                return `/user-bid?filter_user_ids=${data.item.userId}&filter_by_date=${date}`
            },
            viewsLink(data){
                const date = this.moment.unix(data.item.date).format("YYYY-MM-DD");
                return `/vehicle-view?user_id=${data.item.userId}&filter_by_date=${date}`
            },
        }
    }
</script>



// WEBPACK FOOTER //
// resources/js/components/History/AllHistory.vue